/**
 * @generated SignedSource<<1feba3fa6afd2e4038af4a7eb170c896>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedVideoComponentCarousel_componentModule$data = {
  readonly ctaLink: string | null;
  readonly " $fragmentType": "HpSharedVideoComponentCarousel_componentModule";
};
export type HpSharedVideoComponentCarousel_componentModule$key = {
  readonly " $data"?: HpSharedVideoComponentCarousel_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedVideoComponentCarousel_componentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedVideoComponentCarousel_componentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ctaLink",
      "storageKey": null
    }
  ],
  "type": "VideoModule",
  "abstractKey": null
};

(node as any).hash = "a8f17bd855cd421ef24a2cefda425d53";

export default node;
